module.exports = __webpack_public_path__ + "static/media/Jesse Cook Dance Of Spring [Xsongspk.me].e6350778.mp3";